import * as api from "../routes/userroutefront";
import axios from "../config/axios";
import key from "../config/config";

/**
 * Stage 8 — geofencing status.
 *
 * Public and unauthenticated: the block screen has to render for a visitor who
 * has never signed in. The response carries only what the UI needs to render
 * the right screen — allowed, the state, and whether a location was resolved at
 * all. Which vendor answered stays on the server.
 */
export const getGeoStatus = async () => {
  try {
    const respData = await axios({
      url: key.API_URL + api.geoStatus,
      method: "get",
    });
    return {
      status: respData?.data?.status,
      result: respData?.data?.result,
    };
  } catch (err) {
    return { status: false, result: null };
  }
};
